<template>
	<div>
		<div class="title">
			{{ data.name }}
		</div>
		<ul class="extra-bar-warp" v-if="dataList">
			<template v-for="(item, index) in dataList['extra_list']">
				<li class="extra-bar-item" :key="item.name" :class="{ active: valList[index].qty > 0 }"
					v-show="item['hide'] === 0">
					{{ item.name }}
					<stepper :min="0" :max="item['max_number'] !== undefined ? item['max_number'] : 99" v-model="valList[index]['qty']"
						@change="numchange(valList[index])" disable-input />
				</li>
			</template>
		</ul>
	</div>
</template>

<script>
	import {
		stepper
	} from "vant";
	import {
		getVal
	} from "./util";

	export default {
		props: ["data", "value", "rules"],
		data() {
			return {
				valList: [],
				dataList: null,
				sending: false,
				initializing: true,
			};
		},
		mounted() {
			this.initData();
			// 标记初始化完成，后续 watcher 触发时才 emit
			this.$nextTick(() => { this.initializing = false; });
		},
		methods: {
			initData(forceReinit) {
				var data = JSON.parse(JSON.stringify(this.data || {}));
				var rules = JSON.parse(JSON.stringify(this.rules || {}));

				// 合并 rules 到 data（用于 dataList 渲染）
				Object.assign(data, rules);

				var rulesDtlList = rules["group_detail_rules"];

				// 建立 rules 的 default_count 映射：group_detail_code → default_count
				var ruleDefaults = {};
				if (rulesDtlList && Array.isArray(rulesDtlList)) {
					for (var ri = 0; ri < rulesDtlList.length; ri++) {
						var rd = rulesDtlList[ri];
						if (rd['group_detail_code'] !== undefined) {
							ruleDefaults[rd['group_detail_code']] = rd;
						}
					}
				}

				// 处理 extra_list，保存原始值，应用 rules
				for (var index in data["extra_list"]) {
					var extraitem = data["extra_list"][index];
					var itemCode = extraitem["extra_sku"] || extraitem["code"];
					var _r = ruleDefaults[itemCode] || {};

					extraitem['_orig_default_count'] = extraitem['default_count'];
					extraitem['_orig_min_number'] = extraitem['min_number'];
					extraitem['_orig_max_number'] = extraitem['max_number'];
					extraitem['_rule_default_count'] = _r['default_count'];
					Object.assign(extraitem, _r);
					// 优先使用 rules 的 price_times（如果有的话）
					// price_times[0]===0 时为乘数（如风味糖浆），保留原始值，由 loadMoney 乘以 perShotPrice
					// 否则为实际价格（RMB），转换为分
					if (_r['price_times'] && Array.isArray(_r['price_times'])) {
						if (_r['price_times'][0] === 0) {
							extraitem['price_times'] = _r['price_times'];
						} else {
							extraitem['price_times'] = _r['price_times'].map(function(v) { return v * 100; });
						}
					}
				}
				this.dataList = data;

				// 如果父级已设置值（通过 _initTreeDefaults），直接使用，不重新初始化
				// 但 rules 变化时（杯型切换）需要强制重新初始化
				if (!forceReinit && this.value && Array.isArray(this.value) && this.value.length > 0) {
					for (var vi = 0; vi < this.value.length; vi++) {
						this.$set(this.valList, vi, this.value[vi]);
					}
					// 用 rules 的 default_count 修正 qty（仅 must=1 或 is_default=1 的项目）
					var extras = data["extra_list"];
					var qtyChanged = false;
					for (var vi2 = 0; vi2 < this.valList.length; vi2++) {
						if (vi2 < extras.length) {
							var ext = extras[vi2];
							if (ext['must'] === 1 || ext['is_default'] === 1) {
								var dc = ext['default_count'];
								var mn = ext['min_number'] !== undefined ? ext['min_number'] : 0;
								var mx = ext['max_number'] !== undefined ? ext['max_number'] : 99;
								if (dc !== undefined && dc > 0) {
									var newQty = Math.max(mn, Math.min(mx, dc));
									if (this.valList[vi2].qty !== newQty) {
										this.valList[vi2].qty = newQty;
										qtyChanged = true;
									}
								}
							}
						}
					}
					this.loadMoney();
					// qty 修正后通知父级
					if (qtyChanged) {
						this.sending = true;
						this.$emit("input", this.valList);
						this.$nextTick(() => { this.sending = false; });
					}
					return;
				}

				// 初始化val
				var valList = [];
				for (var index2 in data["extra_list"]) {
					var item = data["extra_list"][index2];
					var _val = getVal(this.data.name, item, this.data.code);
					_val["price"] = 0;
					_val["qty"] = 0;

					// 合并后 min_number/max_number/default_count 已含 rules 值（rules 优先）
					var _min = item['min_number'] !== undefined ? item['min_number'] : 0;
					var _max = item['max_number'] !== undefined ? item['max_number'] : 99;
					var _default = item['default_count'];

					if (item['must'] === 1 || item['is_default'] === 1) {
						var defCount = _default !== undefined ? _default : 1;
						_val["qty"] = Math.max(_min, Math.min(_max, defCount));
					}
					// must === 0 且 is_default === 0 时 qty 保持 0，用户勾选后才填入 default_count

					valList.push(_val);
				}

				this.valList = valList;
				// 初始化阶段不 emit，让父级 _initTreeDefaults 设置默认值
				if (!this.initializing) {
					this.sending = true;
					this.$emit("input", valList);
					this.$nextTick(() => { this.sending = false; });
				}
			},
			loadMoney() {
				for (var index in this.valList) {
					var val = this.valList[index];
					var extra = this.dataList["extra_list"][index];
					var qty = val["qty"];
					var priceTimes = extra["price_times"];
					var defaultCount = Number(extra["default_count"] || 0);
					var perShotPrice = Number(extra["price"]) || 0;

					// price_times[0]===0 表示是按份数阶梯计价（如风味糖浆、饮品主体），
					// price_times 是乘数（已转分），需乘以 perShotPrice 得到实际价格
					if (priceTimes && Array.isArray(priceTimes) && priceTimes[0] === 0) {
						var pt = qty < priceTimes.length ? (priceTimes[qty] || 0) : (priceTimes[priceTimes.length - 1] || 0);
						// 默认项（must=1 或 is_default=1）：减去默认份数的乘数（已含在底价中）
						if (extra["must"] === 1 || extra["is_default"] === 1) {
							var defPt = defaultCount < priceTimes.length ? (priceTimes[defaultCount] || 0) : (priceTimes[priceTimes.length - 1] || 0);
							pt = pt - defPt;
							if (pt < 0) pt = 0;
						}
						val["price"] = pt * perShotPrice;
					} else {
						val["price"] = perShotPrice * Math.max(qty - defaultCount, 0);
					}
				}
			},
			numchange(v) {
				// 从0启用时，跳到 min_number（如有）
				var idx = this.valList.indexOf(v);
				var extra = idx >= 0 ? this.dataList["extra_list"][idx] : null;
				if (extra && v["qty"] === 1) {
					var minNum = extra['min_number'];
					if (minNum !== undefined && minNum > 1) {
						v["qty"] = minNum;
					}
				}

				//  获取租总数
				var num = this.valList.map((d) => d["qty"]).reduce((v1, v2) => v1 + v2);

				if (this.dataList["group_min_mumber"] > num) {
					v["qty"] += 1;
				} else if (this.dataList["group_max_number"] < num) {
					this.$msg("每组不能超过" + this.dataList["group_max_number"]);
					this.$nextTick(() => {
						v["qty"] -= 1;
					});
				}
				// setTimeout(() => {
				this.loadMoney();
				// }, 10);
				// 通知父组件价格已更新
				this.sending = true;
				this.$emit("input", this.valList);
				this.$nextTick(() => { this.sending = false; });
			},
		},
		watch: {
			value: {
				handler(val) {
					if (this.initializing || this.sending) return;
					if (val && Array.isArray(val) && val.length > 0) {
						// 替换整个数组以确保 Vue 2 响应式更新
						var newList = [];
						for (var vi = 0; vi < val.length; vi++) {
							newList.push(Object.assign({}, val[vi]));
						}
						this.valList = newList;
					}
				},
				deep: true,
			},
			rules: {
				handler() {
					if (this.initializing) return;
					this.initData(true);
				},
				deep: true,
			},
		},
		components: {
			stepper,
		},
	};
</script>

<style lang="scss" scoped>
	.extra-bar-warp {
		.extra-bar-item {
			border: 1px solid #ddd;
			line-height: 88px;
			height: 88px;
			padding: 0 20px;
			margin-bottom: 20px;
			border-radius: 16px;

			display: flex;
			align-content: center;
			justify-content: space-between;

			&.active {
				border-color: #5bad70;
				background: #5bad70;
				color: #fff;
			}
		}
	}
</style>
